export enum HeaderModals {
  connect = 'connect',
  disconnect = 'disconnect',
  none = 'none',
}
